module.exports = {"140431100":"沁河镇","140431101":"郭道镇","140431102":"灵空山镇","140431103":"王和镇","140431105":"王陶镇","140431107":"景凤镇","140431200":"中峪乡","140431201":"法中乡","140431202":"交口乡","140431203":"聪子峪乡","140431204":"韩洪乡","140431207":"赤石桥乡","140431400":"沁源经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140431.json
// module id = 392
// module chunks = 0